/** ----------------------------------------
     Service
 ---------------------------------------- */

import { OrganisationService } from '@store/service/OrganisationService';
import { FileService } from '@store/service/FileService';
import { merge, omitBy, isNil } from 'lodash';

/** ----------------------------------------
     Actions
 ---------------------------------------- */

const actions = {
    async fetchAll({ commit }: any) {
        const organisationService = new OrganisationService(this);
        return organisationService.getOrganisationList()
            .then(response => {
                if (response instanceof Error)
                    return response;

                const data = response.data;
                commit('setList', data);
                return data;
            });
    },

    async fetch({ commit }: any, payload: any) {
        const organisationService = new OrganisationService(this);
        return organisationService.getOrganisation(payload)
            .then(response => {
                if (response instanceof Error)
                    return response;

                const data = response.data;
                return data;
            });
    },

    async create({ commit }: any, payload: any) {
        const organisationService = new OrganisationService(this);

        // Create organisation
        return organisationService.postOrganisation(payload)
            .then(response => {
                if (response instanceof Error)
                    return response;
                const organisation = response.data;

                // Fetch list again
                return this.dispatch('organisation/fetchAll').then(response => {

                    // Return organisation
                    return organisation;
                })
            });
    },

    async update({ commit }: any, payload: any) {
        const id = payload.id;
        let data = merge({}, payload);

        // Remove data that shouldn't be updated
        delete data.id;
        delete data.projects;

        // Remove props with value null
        data = omitBy(data, isNil)

        const organisationService = new OrganisationService(this);
        return organisationService.putOrganisation(id, data)
            .then(response => {
                if (response instanceof Error)
                    return response;

                return true;
            });
    },

    async uploadFile({ commit }: any, payload: any) {
        const fileService = new FileService(this);
        return fileService.postFile(payload)
            .then(response => {
                if (response instanceof Error)
                    return response;

                return response.data;
            });
    },

    async fetchFiles({ commit }: any, payload: any) {
        const fileService = new FileService(this);
        return fileService.getFiles(payload, 'organisation');
    },
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default actions;